module.exports = __webpack_public_path__ + "img/jmc_thumbnail.1d2f832b.png";